/*eslint-disable*/
import React from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
// reactstrap components
import { Button, Card, CardHeader, CardBody, CardTitle, Collapse, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, FormGroup, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Media, NavbarBrand, Navbar, NavItem, NavLink, Nav, Progress, Table, Container, Row, Col} from "reactstrap";
var ps;
import {Icon} from 'react-fa';
import FindOrgsByEmail from "../FindOrgsByEmail/index.jsx";

class Sidebar extends React.Component {
  state = {
    collapseOpen: false,
	show_find_by_email_modal: false,
  };
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
  }

  toggle_find_by_email_modal = () => {this.setState({show_find_by_email_modal: !this.state.show_find_by_email_modal})}
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };

  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
 
  // creates the links that appear in the left menu / Sidebar
  createLinks = (routes, orgs_at_risk_with_no_note, pending_offline_payments_count, comms_unread_count) => {
    return routes.map((prop, key) => {
      let label = prop.name;
      if (prop.name === 'Orgs at Risk' && orgs_at_risk_with_no_note) {
        label = `${prop.name} (${orgs_at_risk_with_no_note})`;
      }
      const show_payments_badge = prop.has_pending_offline_payments_badge && pending_offline_payments_count > 0;
      const show_comms_badge = prop.has_comms_badge && comms_unread_count > 0;
      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={this.closeCollapse}
            activeClassName="active"
			style={{color:'#a6a6a6'}}
          >
            <div style={{width:'40px'}}><Icon style={{color:'#a6a6a6'}} name={prop.icon} size="lg" className="mr-3" /></div>
            <span>{label}</span>
            {show_payments_badge ? (
              <span
                style={{
                  marginLeft: '8px',
                  background: '#ff4d4f',
                  color: 'white',
                  borderRadius: '10px',
                  padding: '1px 7px',
                  fontSize: '11px',
                  fontWeight: 700,
                  lineHeight: '16px',
                }}
              >
                {pending_offline_payments_count > 99 ? '99+' : pending_offline_payments_count}
              </span>
            ) : null}
            {show_comms_badge ? (
              <span
                style={{
                  marginLeft: '8px',
                  background: '#2f6fed',
                  color: 'white',
                  borderRadius: '10px',
                  padding: '1px 7px',
                  fontSize: '11px',
                  fontWeight: 700,
                  lineHeight: '16px',
                }}
              >
                {comms_unread_count > 99 ? '99+' : comms_unread_count}
              </span>
            ) : null}
          </NavLink>
        </NavItem>
      );
    });
  };

  logout_and_redirect = async() => {
    if(this.props.user_details){
        try {
            let resp = await general_fetch({url:'user/logout'})
        } catch(err) {
            console.log(err)
        }
    }
    window.location.href = window.location.origin.includes('bdp') ? global.config.auth_redirect_path.replace('csp', 'bdp') : global.config.auth_redirect_path
  }

  render() {
    const { bgColor, routes, logo, orgs_at_risk_with_no_note, pending_offline_payments_count, comms_unread_count } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    return (
      <Navbar 
        className="navbar-vertical fixed-left navbar-light" 
        expand="md" 
        id="sidenav-main" 
        style={{
          backgroundColor: '#000',
          margin: 5,
          borderRadius: 5,
          maxWidth: 240,
          padding: 22
        }}
      >
		<FindOrgsByEmail 
			open = {this.state.show_find_by_email_modal}
			toggle={this.toggle_find_by_email_modal}
			action_name={'Manage'}
			action_function={(single_org) => {window.location.href = ("/home/store_dashboard/" + single_org.id + '/7')}}
		/>
        <Container fluid>
          {/* Toggler */}
          <button className="navbar-toggler" type="button" onClick={this.toggleCollapse}>
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img alt="Infurnia" className="navbar-brand-img mb-2" src={require("../../assets/img/brand/whiteLogo.png")}/>
            <br /><div style={{fontSize:window.location.origin.includes('bdp')?'0.75rem':'0.75rem', color:'#a6a6a6', fontWeight:600, lineHeight:'1.5'}}>{window.location.origin.includes('bdp') ? 'BUSINESS DEVELOPMENT' : 'CUSTOMER SUCCESS'} PORTAL</div>
          </NavbarBrand>
          {/* User */}
          <Nav className="align-items-center d-md-none">
            {/* <UncontrolledDropdown nav>
              <DropdownToggle nav className="nav-link-icon">
                <i className="ni ni-bell-55" />
              </DropdownToggle>
              <DropdownMenu
                aria-labelledby="navbar-default_dropdown_1"
                className="dropdown-menu-arrow"
                right
              >
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another action</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={require("../../assets/img/icons/avatar.png")}
                    />
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={e => e.preventDefault()}>
                  <i className="ni ni-user-run" />
                  <span style={{cursor:'pointer'}}>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* Collapse */}
          <Collapse navbar isOpen={this.state.collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={this.toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Form */}
            <Form className="mt-4 mb-3 d-md-none">
              <InputGroup className="input-group-rounded input-group-merge">
                <Input
                  aria-label="Search"
                  className="form-control-rounded form-control-prepended"
                  placeholder="Search"
                  type="search"
                />
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <span className="fa fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Form>
            {/* Navigation */}
            <Nav navbar>{this.createLinks(routes, orgs_at_risk_with_no_note, pending_offline_payments_count, comms_unread_count)}</Nav>
            {/* Divider */}
            <hr style={{borderTop:'1px solid #a6a6a6'}} className="my-3" />
			{
				window.location.origin.includes('bdp')?'':
				<Nav navbar className='cp'>
					<NavItem>
						<NavLink
							onClick={this.toggle_find_by_email_modal}
							style={{color:'#a6a6a6'}}
						>
							<div style={{width:'40px'}}><Icon style={{color:'#a6a6a6'}} name={'search'} size="lg" className=" mr-3" /></div>
							Find Orgs by Email
						</NavLink>
					</NavItem>
				</Nav>
			}
            <Nav navbar className='cp'>
			<NavItem>
				<NavLink
					onClick={this.logout_and_redirect}
					style={{color:'#a6a6a6'}}
				>
					<div style={{width:'40px'}}><Icon style={{color:'#a6a6a6'}} name={'power-off'} size="lg" className=" mr-3" /></div>
					Logout
				</NavLink>
			</NavItem>
			</Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};

export default Sidebar;
